/*
 * @Author: your name
 * @Date: 2021-11-23 18:08:04
 * @LastEditTime: 2021-11-24 16:44:48
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/store/module/common/mutation.js
 */
import * as Types from '../../mutations-types'
import {saveLocalDicOption, saveLocalArea} from '@/utils/storage'
  export default {
    [Types.GET_DIC_OPTION_LIST] (state, res) {
      state.channelList = res.channels || []
      state.departmentList = res.departments || []
      saveLocalDicOption(res)
    },
    [Types.GET_AREA_LIST] (state, res) {
      state.areaList = res || []
      saveLocalArea(res)
    }
  }